import {
  isEnterprisePlan,
  isPublicPlan,
} from "../../../helpers/pricingPlans.mjs";

// Plans offered on the event page, by plan_slug (they are picked from the
// plans the pricing page lists, so hidden legacy prices never show).
export const EVENT_PLAN_SLUGS = ["rhino-lite", "rhino-pro", "rhino-legend"];

export const eventPlans = (monthlyPlans) =>
  (monthlyPlans || []).filter(
    (plan) =>
      isPublicPlan(plan) &&
      !isEnterprisePlan(plan) &&
      EVENT_PLAN_SLUGS.includes(plan.plan_slug)
  );

// The normal checkout with the event's plan and Promo Code already applied
// (checkout/Form.jsx pre-fills and applies ?code=).
export const eventCheckoutUrl = (plan, code) =>
  `/checkout/${plan.encoded_id}` +
  (code ? `?code=${encodeURIComponent(code)}` : "");

// ?plan=<plan_slug> from the QR link, else the highlighted plan, else the first.
export const defaultPlanId = (plans, slug) => {
  const bySlug = slug && plans.find((plan) => plan.plan_slug === slug);
  const best = plans.find((plan) => parseInt(plan.best_status, 10) === 1);
  return (bySlug || best || plans[0])?.encoded_id || null;
};
